import { createClass as _createClass, inherits as _inherits, classCallCheck as _classCallCheck, createSuper as _createSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';

/* eslint max-classes-per-file: ["error", 2] */

/** A base GlobalEventDispatcher class, which has the right interface but does nothing. This is what
 * we'll return in the even we find we're not running in a browser. */
var NullGlobalEventDispatcher = /*#__PURE__*/function () {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function NullGlobalEventDispatcher(_eventName) {
    _classCallCheck(this, NullGlobalEventDispatcher);
  }

  _createClass(NullGlobalEventDispatcher, [{
    key: "destroy",
    value: function destroy() {}
  }, {
    key: "add",
    value: function add(_listener) {}
  }, {
    key: "remove",
    value: function remove(_listener) {}
  }]);

  return NullGlobalEventDispatcher;
}();
/** A singleton for sharing permanent event handlers across multiple instances of SwipeController.
 * Assign the one, shared global event listener on the window!
 * This will make sure touchmove events in Safari are cancelable, but allow add and remove offset
 * secondary event listeners with the same semantics as .addEventListener(). */


var GlobalEventDispatcher = /*#__PURE__*/function (_NullGlobalEventDispa) {
  _inherits(GlobalEventDispatcher, _NullGlobalEventDispa);

  var _super = _createSuper(GlobalEventDispatcher);

  function GlobalEventDispatcher(eventName) {
    var _this;

    _classCallCheck(this, GlobalEventDispatcher);

    _this = _super.call(this, eventName);
    /** The canonical list of registered listeners that we will dispatch events to. */

    _this.listeners = new Set();
    /** Whether we should print debug info to the console */

    _this.debug = false;

    _this.onEvent = function (e) {
      return _this.listeners.forEach(function (listener) {
        return listener(e);
      });
    };

    _this.eventName = eventName;
    window.addEventListener(eventName, _this.onEvent, {
      passive: false
    });

    _this.debugToConsole();

    return _this;
  }

  _createClass(GlobalEventDispatcher, [{
    key: "destroy",
    value: function destroy() {
      window.removeEventListener(this.eventName, this.onEvent);
    }
    /** Add a touch event listener */

  }, {
    key: "add",
    value: function add(listener) {
      this.listeners.add(listener);
      this.debugToConsole();
    }
    /** Remove a touch event listener */

  }, {
    key: "remove",
    value: function remove(listener) {
      this.listeners["delete"](listener);
      this.debugToConsole();
    }
    /** log debug data */

  }, {
    key: "debugToConsole",
    value: function debugToConsole() {
      if (this.debug) {
        /* eslint-disable no-console */
        console.log('listeners:', this.listeners);
      }
    }
  }]);

  return GlobalEventDispatcher;
}(NullGlobalEventDispatcher);
/** Singleton object creator */

function globalEventDispatcher(eventName) {
  // If there's no window object, we're running in Node, probably for SSR, and we should return a
  // thing that does nothing so consuming code doesn't have to branch.
  if (typeof window === 'undefined') {
    return new NullGlobalEventDispatcher(eventName);
  } // If there's no globalEventDispatchers yet, create it!


  if (!window.globalEventDispatchers) {
    window.globalEventDispatchers = {};
  } // If there's no dispatcher for eventName yet, create it


  var existingDispatcher = window.globalEventDispatchers[eventName];
  if (existingDispatcher) return existingDispatcher; // Make a new one then!

  var newDispatcher = new GlobalEventDispatcher(eventName);
  window.globalEventDispatchers[eventName] = newDispatcher;
  return newDispatcher;
}

export { GlobalEventDispatcher, globalEventDispatcher };
